import React from "react";
import { View } from "native-base";

interface SeparatorDashedProps {}

export const SeparatorDashed = ({}: SeparatorDashedProps) => {
  return (
    <View
      borderColor={"neutral.BorderAndDisabled"}
      borderWidth={"1.2px"}
      borderStyle={"dashed"}
      borderRadius={"1px"}
      borderBottomColor={"transparent"}
      borderRightColor={"transparent"}
      borderLeftColor={"transparent"}
    />
  );
};

export default SeparatorDashed;
